import { cn } from "@core-ui/utils/cn";
import t from "@ext/localization/locale/translate";
import { FloatingIconButton } from "@ui-kit/FloatingPanel/components/FloatingIconButton";
import { forwardRef } from "react";

export interface GlassPanelHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
	title: React.ReactNode;
	actions?: React.ReactNode;
	onClose?: () => void;
}

export const GlassPanelHeader = forwardRef<HTMLDivElement, GlassPanelHeaderProps>((props, ref) => {
	const { className, title, actions, onClose, ...otherProps } = props;
	return (
		<div
			className={cn(
				"absolute left-0 right-0 top-0 z-10 flex select-none items-center justify-between gap-4 p-2 pl-4 pt-2 focus-visible:outline-none",
				className,
			)}
			ref={ref}
			{...otherProps}
		>
			<span className="flex min-w-0 flex-row items-center gap-2 text-base font-semibold">{title}</span>
			<div className="flex flex-row items-center" onPointerDown={(e) => e.stopPropagation()}>
				{actions}
				{onClose && (
					<FloatingIconButton
						aria-label={t("close")}
						className="stroke-[1.75px]"
						data-testid="floating-panel-close"
						icon="x"
						onClick={onClose}
						size="md"
					/>
				)}
			</div>
		</div>
	);
});
